import { setPageType } from "action/utils/setPageType";
import { setUrlInfo } from "action/utils/setUrlInfo";
import { IPageContent } from "api/interfaces/static-content.type";
import usePreserveScroll from "hoc/usePreserveScroll";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { wrapper } from "store";
import { TIRE_SIZE_PAGE } from "util/product/product-constants";
import nextI18nextConfig from "../../../next-i18next.config";
import CategoryTierContainer from "../../modules/category/CategoryTierContainer";
import TiresBySizeMetaHead from "../../modules/category/tires/TiresBySizeMetaHead";
import TiresSizeExplanation from "../../modules/category/tires/TiresSizeExplanation";

const NotFound = dynamic(() => import(/* webpackChunkName: "notfound" */ "component/notfound/notfound.component"), { ssr: false });

interface IProps{
  staticContent: IPageContent;
}

function TyreSize(props: IProps) {
  const {
    actualResponse,
    pageType,
    staticContent,
    isSSR,
    urlInformation,
  } = props;
  console.log("tire size static content", staticContent);
  const { query } = useRouter();
  const { sizes } = query;
  const dispatch = useDispatch();
  usePreserveScroll();

  useEffect(() => {
    dispatch(setPageType(TIRE_SIZE_PAGE));
    dispatch(setUrlInfo(urlInformation));
  }, [urlInformation]);

  const parsedSize = sizes.replace("-", "/");
  if (actualResponse.productsAggregation?.products?.products?.length) {
    const pageDisplayableTitle = `Tires ${sizes.replace("-", "/")}`;
    staticContent.pageDetails.pageDisplayableTitle = pageDisplayableTitle;
    return (
      <>

        <TiresBySizeMetaHead
          {...actualResponse}
          size={sizes}
          products={actualResponse.productsAggregation.products.products}
        />

        <CategoryTierContainer
          {...{
            staticContent, pageType, isSSR, actualResponse,
          }}
          innerQuery={{
            sizes: parsedSize,
          }}
          url="/tires"
          hideMetaHead
          comonTop={(
            <div style={{ width: "100%", backgroundColor: "white" }}>

              <div className="container p-t-10 p-b-10">

                <TiresSizeExplanation
                  size={sizes}
                />
              </div>
            </div>
          )}
        />
      </>
    );
  }

  return <NotFound />;
}

const TyreSizePage = TyreSize;

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({
  query, res, locale, req,
}) => {
  const { getInitialProps } = await import("../../modules/pathName");
  const { sizes, availabilities } = query;
  const parsedSize = sizes;
  const buildQuery = {
    tier2: "tires",
    tier3: "tires",
    pathname: "tires",
    innerQuery: {
      sizes: parsedSize.replace("-", "/"),
    },
    availabilities,
  };

  const localesToLoad = ["common", "category-map", "category"];
  const ssrTranslations = await serverSideTranslations(locale, localesToLoad, nextI18nextConfig);
  ssrTranslations._nextI18Next.initialI18nStore = {
    [locale]: ssrTranslations._nextI18Next.initialI18nStore[locale],
  };
  const ssrData = await getInitialProps({
    store, query: buildQuery, res, locale, req,
  });
  store.dispatch(setPageType(TIRE_SIZE_PAGE));
  console.log("ssrData", ssrData);
  return {
    props: {
      ...ssrTranslations,
      ...ssrData,
    },
  };
});

export default TyreSizePage;
export const config = { amp: false };
